import React from "react";

import {
  Card,
  CardBody,
  Grid,
  GridItem
} from "@patternfly/react-core";

import DashboardBranches from "../../dashboard/components/Branches/DashboardBranches";

import EducationDashboardHeader from "./EducationDashboardHeader";
import EducationHeroCard from "./EducationHeroCard";

const EducationEduHero = ({
  branches,
  isAuthUser,
  themeVersion
}) => {
  if (isAuthUser) {
    return <EducationDashboardHeader />;
  }

  const publishedBranches = Object.values(branches ?? {}).filter(
    (branch) => branch?.organization_branch_published === true
  );

  const showHeroImage = publishedBranches.length > 1;
  return (
    <Grid hasGutter>
      <GridItem span={12} lg={6}>
        <Card isFullHeight isGlass>
          <CardBody>
            <DashboardBranches
              branches={branches}
              isAuthUser={false}
              themeVersion={themeVersion}
            />
          </CardBody>
        </Card>
      </GridItem>
      <GridItem span={12} lg={6}>
        <EducationHeroCard
          showImage={showHeroImage}
        />
      </GridItem>
    </Grid>
  );
};

export default EducationEduHero;